/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Renderer2, RendererFactory2, Injectable } from '@angular/core';
import { IcepanelComponent } from './icepanel.component';
import { IcecontrolComponent, IceheadercontrolComponent } from './icecontrol.component';
import { Iceutility } from '../../services/iceutility';
import { MatTableDataSource } from '@angular/material';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class IcepanelService {
	containers: any = {};
	controls: any = {};
	panels: any = {};
	panelKey: string = "";
	controlId: string = "";
  sections: any = {};
  matSortChangeSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor() {
	}

    public getContainer(panelElem: any): any {
        if (panelElem === null) {
            return null;
        }

        let results = panelElem.getElementsByClassName("container-fluid");
        if (results != null && results.length > 0) {
            return results[0];
        }
        return null;
	}

	public getPanel(panelElem: any): any {
		if (panelElem === null) {
			return null;
		}

		let results = panelElem.getElementsByClassName("card");
		if (results != null && results.length > 0) {
			return results[0];
		}
		return null;
	}

	public getSectionElement(sectionElem: any): any {
		if (sectionElem === null) {
			return null;
		}

		let results = sectionElem.getElementsByClassName("section-default-overflow");
		if (results != null && results.length > 0) {
			return results[0];
		}
		return null;
	}

  createContainer(renderer: Renderer2, parent: HTMLElement, controlId: string): boolean {
		try {
			if (controlId == null) throw "Error: Invalid control Id in panelcontainer.Create(...).";

			let containerdiv: HTMLDivElement = renderer.createElement("div");
			renderer.setAttribute(containerdiv, "id", controlId);
			renderer.addClass(containerdiv, "container-fluid");
			renderer.appendChild(parent, containerdiv);

			this.containers[controlId] = containerdiv
			return true;
		} catch (e) {
			console.log(e);
		}

		return false;
	}

  public addPanel(renderer: Renderer2, panel: IcepanelComponent, id: string, rowIdx: number, columnIdx: number, pTag: string, pKey: string, ttle: string): boolean {
		if (panel == null) return false;
		if (id == null || id == "") return false;
		if (pTag == null || pTag == "") return false;

		let div: HTMLElement = renderer.selectRootElement("#" + id);
		if (div == null) return false;

		try {
			if (pKey == null || pKey == "") {
				pKey = Iceutility.guid(false);
			}

			// To do AR 4/20/18:  Check rowIndex against the number of iPanelRow's and if the row already exists then use the rowIndex otherwise create rowIndex
			let panelRow: HTMLDivElement = renderer.createElement("div");
			renderer.addClass(panelRow, "row");
			renderer.setAttribute(panelRow, "iPanelRow", "");
			this.panelKey = pKey;

			// To do AR 4/20/18:  Check columnIndex and rowIndex against the number of iPanelCol's and if the column already exists then use the columnIndex otherwise create columnIndex
			let panelCol: HTMLDivElement = renderer.createElement("div");
			renderer.setAttribute(panelCol, "class", "col-lg-12 col-md-12 col-sm-12 col-xs-12");
			renderer.setAttribute(panelCol, "iPanelCol", "");

			if (false == this.createPanel(renderer, panel, panelCol as any, id, pTag, pKey, ttle))
				throw "Unable to create panel: " + ttle;

			renderer.appendChild(panelRow, panelCol);
			renderer.appendChild(div, panelRow);
		} catch (e) {
			console.log(e);
			return false;
		}
		return true;
	}

  private createPanel(renderer: Renderer2, panel: IcepanelComponent, parent: HTMLElement, parentId: string, tag: string,
		key: string, title: string) {

		if (parent == null) {
			return false;
		}

		try {
			if (key == null || key == "") {
				key = Iceutility.guid(false);
				panel.panelKey = key;
			}

			let panelElem: HTMLElement = renderer.createElement("div");
			renderer.addClass(panelElem, "card");

			let id = parentId + "_" + tag + "_" + "Panel" + "_" + key;

			if (!Iceutility.isdefined(this.controlId) || this.controlId === "") {
				this.controlId = id;
			}
			renderer.setAttribute(panelElem, "id", id);
			renderer.setAttribute(panelElem, "iPanel", tag);

			let panelHeading: HTMLDivElement = renderer.createElement("div");
			renderer.addClass(panelHeading, "card-header");
			renderer.setStyle(panelHeading, "width", "100%");
			renderer.setAttribute(panelHeading, "id", id + "_" + "Heading");

			let span: HTMLSpanElement = renderer.createElement("span");
			renderer.addClass(span, "card-title");
			renderer.setProperty(span, "innerText", title);
			renderer.appendChild(panelHeading, span);

			let panelBody: HTMLDivElement = renderer.createElement("div");
			renderer.addClass(panelBody, "card-body");
			renderer.setAttribute(panelBody, "id", id + "_" + "Body");

			renderer.appendChild(panelElem, panelHeading);
			renderer.appendChild(panelElem, panelBody);
			renderer.appendChild(parent, panelElem);

			panel.controlId = id;
			this.panels[id] = panel;
			return true;
		}
		catch (e) {
			console.log(e);
		}
		return false;
	}

	public getHeading(panelElem: any): any {
		if (panelElem === null) {
			return null;
		}

		let results = panelElem.getElementsByClassName("card-header");
		if (results != null && results.length > 0) {
			return results[0];
		}
		return null;
	}

	public getBody(panelElem: any): any {
		if (panelElem === null) {
			return null;
		}

		let results = panelElem.getElementsByClassName("card-body");
		if (results != null && results.length > 0) {
			return results[0];
		}

		return null;
	}

  public addFooter(renderer: Renderer2, panelElem: any): any {
		if (panelElem === null) {
			return null;
		}

		let result = this.getFooter(panelElem);
		if (result !== null) {
			return result;
		}

		let panelFooter: HTMLElement = document.createElement("div");
		renderer.addClass(panelFooter, "card-footer");

		let id = panelElem["id"] + "_" + "Footer";
		renderer.setAttribute(panelFooter, "id", id);

		renderer.appendChild(panelElem, panelFooter);
		return panelFooter;
	}

	public deleteFooter(panelElem: any) {
		let footer = this.getFooter(panelElem);

		if (footer !== null && footer !== undefined) {
			footer.remove();
		}
	}

	public getFooter(panelElem: any): any {
		if (panelElem === null) {
			return null;
		}

		let results = panelElem.getElementsByClassName("card-footer");
		if (results !== null && results.length > 0) {
			return results[0];
		}

		return null;
	}

  public addHeaderControl(renderer: Renderer2, ctrl: IceheadercontrolComponent, panelElem: HTMLElement, element: HTMLElement, type: string, prop: any,
		field: string, val: string) {

		var header = this.getHeading(panelElem);
		if (header === null) {
			return false;
		}

		if (element === null) {
			return false;
		}

		let ret: boolean = false;
		try {
			ret = this.addControl(renderer, ctrl, header, element);
		}
		catch (e) {
			console.log(e);
		}

		return ret;
	}

  addControl(renderer: Renderer2, ctrl: IcecontrolComponent, parent: HTMLElement, elementToAppend: HTMLElement): boolean {
		if (ctrl == null) return false;
		if (parent == null) return false;
		if (elementToAppend == null) return false;
		if (ctrl.type == null || ctrl.type == "") return false;

		let id = "";

		try {
			switch (ctrl.type) {
				case "anchor": {
					let anchor: HTMLElement = renderer.createElement('a');
					if (ctrl.controlId != null && ctrl.controlId != "")
						id = ctrl.controlId;
					else
						id = ctrl.controlId = parent["id"] + "_" + ctrl.type + "_" + Iceutility.guid(false);

					renderer.setAttribute(anchor, "iPanelCol", "");
					renderer.setStyle(anchor, "cursor", "pointer");

					if (Iceutility.isdefined(ctrl.properties['value'])) {
						anchor.innerHTML = ctrl.properties['value'];
					} else if (ctrl.value != "") {
						anchor.innerHTML = ctrl.value;
					}

					if (Iceutility.isdefined(ctrl.properties['href'])) {
						anchor["href"] = ctrl.properties['href'];
					}
					else {
						anchor["href"] = "#";
					}

					if (ctrl.events != null) {
						if (ctrl.events["click"] != null) {
							let simple = renderer.listen(anchor, 'click', (evt) => {
								ctrl.events["click"](evt);
							});
						}
					}
					renderer.appendChild(elementToAppend, anchor);
					break;
				}
			}

			if (id != null && id.length > 0) {
				if (this.controls[id] != null) {
					console.log("Error: Duplicate control " + id + ". Unable to addcontrol to list of controls in Panel.");
				}
				else {
					this.controls[id] = ctrl;
				}
			}
		}
		catch (e) {
			console.log(e);
		}

		return true;
	}

  public addSection(renderer: Renderer2, parent: HTMLElement, sectionTag: string, width: string, properties: any) {
		if (sectionTag === null || sectionTag.length === 0) {
			console.log("Invalid section tag.");
			return null;
		}

		let section = null;
		var body = this.getBody(parent);
		if (body === null) {
			return null;
		}

		try {
			section = renderer.createElement("div");
			let secid = this.controlId + "_" + sectionTag +
				"_" + "Section" + (this.panelKey == null || this.panelKey.length == 0 ? "" : "_" + this.panelKey);

			this.sections[secid] = section;
			renderer.setAttribute(section, "id", secid);
			renderer.setAttribute(section, "iSection", sectionTag);
			renderer.addClass(section, "section-default-overflow");
			renderer.addClass(section, "scroll");

			if (Iceutility.isdefined(properties)) {
				let sectionWidth = properties["width"];
				let sectionFloat = properties["float"];

				if (Iceutility.isdefined(sectionWidth)) {
					renderer.setStyle(section, "width", sectionWidth);
				}

				if (Iceutility.isdefined(sectionFloat)) {
					if (sectionFloat === "left") {
						renderer.setStyle(section, "clear", "both");
					}
					renderer.setStyle(section, "float", sectionFloat);
				}
			}

			renderer.appendChild(body, section);
		}
		catch (e) {
			console.log(e);
		}

		return section;
	}

	public deleteSection(tag, key) {
		if (tag == null || tag.length == 0)
			return;

		var element = this.getSection(tag, key);
		if (element != null) {
			element.outerHTML = "";
			delete this.sections[element.id];
		}
	}

	public getSection(tag, key) {
		if (tag == null || tag.length == 0) {
			return null;
		}

		var secid = this.controlId + "_" + tag + "_" +
			"Section" + (this.panelKey == null || this.panelKey.length == 0 ? "" : "_" + this.panelKey);
		return document.getElementById(secid);

	}

  public hideSection(renderer: Renderer2, tag, key) {
		if (tag == null || tag.length == 0) {
			return;
		}

		var element = this.getSection(tag, key);
		if (element != null) {
			renderer.setStyle(element, "display", "none");
		}
	}

  public showSection(renderer: Renderer2, tag, key) {
		if (tag == null || tag.length == 0) {
			return;
		}

		var element = this.getSection(tag, key);
		if (element != null) {
			renderer.setStyle(element, "display", "block");
		}
	}

  public addMaterialGrid(renderer: Renderer2, parent: HTMLElement, gridTag: string, rows: object[], columns: object[]): boolean {
		try {
			if (!Iceutility.isdefined(rows)) {
				console.log("Source not defined");
				return false;
			}
			var body = this.getBody(parent);
			if (body === null) {
				return null;
			}

			let dataSource = new MatTableDataSource(rows);
			let matTable: HTMLElement = renderer.createElement("mat-table");
			renderer.setProperty(matTable, "[dataSource]", "dataSource");
			renderer.setProperty(matTable, "#table", "");

			for (let icol = 0; icol < columns.length; icol++) {
				let col = columns[icol];
				if (!Iceutility.isdefined(col)) {
					continue;
				}
				
				let container: HTMLElement = renderer.createElement("ng-container");
				renderer.setAttribute(container, "matColumnDef", col["columnValue"]);

				let headerCell: HTMLElement = renderer.createElement("mat-header-cell");
				renderer.setProperty(headerCell, "*matHeaderCellDef", "");
				headerCell.innerHTML = col["columnDisplay"];
				renderer.appendChild(container, headerCell);

				let cell: HTMLElement = renderer.createElement("mat-cell");
				cell.setAttribute("*matCellDef", "let element");
				cell.innerHTML = "{{ element['columnValue'] }}";
				renderer.appendChild(container, cell);

				//<mat-row * matRowDef="let row; columns: displayedColumns;" > </mat-row>

				renderer.appendChild(matTable, container);
			}

			let headerRow: HTMLElement = renderer.createElement("mat-header-row");
			renderer.setProperty(headerRow, "*matHeaderRowDef", "iColumns");
			renderer.appendChild(matTable, headerRow);

			let row: HTMLElement = renderer.createElement("mat-row");
			renderer.setProperty(row, "*matRowDef", "let row; columns: iColumns;");
			renderer.appendChild(matTable, row);

			renderer.appendChild(body, matTable);
			return true;
		} catch (e) {
			console.log(e.message);
		}
	}
}
